import { ArrowRight, BarChart3, BookOpen, FileText, FolderArchive, HardDrive, KeyRound, Settings2, ShieldCheck } from "lucide-react";

type Props = {
  onOpenManual: () => void;
  onOpenIndicadores: () => void;
  onOpenBiblioteca: () => void;
  onOpenSoa: () => void;
  onOpenDocumentosSistema: () => void;
  onOpenInventarioDispositivos: () => void;
  onOpenInventarioSoftware: () => void;
  onOpenControlesInformatica: () => void;
};

export function Iso2700127701Hub({ onOpenManual, onOpenIndicadores, onOpenBiblioteca, onOpenSoa, onOpenDocumentosSistema, onOpenInventarioDispositivos, onOpenInventarioSoftware, onOpenControlesInformatica }: Props) {
  return (
    <section className="calidad-hub-grid">
      <button type="button" className="calidad-hub-card" onClick={onOpenManual}>
        <span className="calidad-hub-card-icon"><BookOpen size={22} /></span>
        <div className="calidad-hub-card-body">
          <div className="calidad-hub-card-eyebrow">Documento compartido</div>
          <h2 className="calidad-hub-card-title">Manual del Sistema Integrado</h2>
          <p className="calidad-hub-card-copy">
            Consulta el manual vigente compartido con ISO 9001-14001, descarga el Word original y revisa su control documental.
          </p>
        </div>
        <span className="calidad-hub-card-action">Abrir <ArrowRight size={16} /></span>
      </button>

      <button type="button" className="calidad-hub-card" onClick={onOpenIndicadores}>
        <span className="calidad-hub-card-icon"><BarChart3 size={22} /></span>
        <div className="calidad-hub-card-body">
          <div className="calidad-hub-card-eyebrow">Sección compartida</div>
          <h2 className="calidad-hub-card-title">Indicadores</h2>
          <p className="calidad-hub-card-copy">
            Consulta y actualiza los nueve indicadores compartidos, sus valores de referencia, seguimiento, gráficos y control documental.
          </p>
        </div>
        <span className="calidad-hub-card-action">Abrir <ArrowRight size={16} /></span>
      </button>

      <button type="button" className="calidad-hub-card" onClick={onOpenBiblioteca}>
        <span className="calidad-hub-card-icon"><FolderArchive size={22} /></span>
        <div className="calidad-hub-card-body">
          <div className="calidad-hub-card-eyebrow">ISO 27001-27701</div>
          <h2 className="calidad-hub-card-title">Biblioteca</h2>
          <p className="calidad-hub-card-copy">
            Repositorio independiente de Oficina y Proveedores para documentación vinculada a seguridad y privacidad.
          </p>
        </div>
        <span className="calidad-hub-card-action">Abrir <ArrowRight size={16} /></span>
      </button>

      <button type="button" className="calidad-hub-card" onClick={onOpenSoa}>
        <span className="calidad-hub-card-icon"><ShieldCheck size={22} /></span>
        <div className="calidad-hub-card-body">
          <div className="calidad-hub-card-eyebrow">ISO 27001-27701</div>
          <h2 className="calidad-hub-card-title">SOA</h2>
          <p className="calidad-hub-card-copy">
            Gestiona la declaración de aplicabilidad y el plan del Anexo A con controles, evidencias, responsables y seguimiento.
          </p>
        </div>
        <span className="calidad-hub-card-action">Abrir <ArrowRight size={16} /></span>
      </button>

      <button type="button" className="calidad-hub-card" onClick={onOpenDocumentosSistema}>
        <span className="calidad-hub-card-icon"><FileText size={22} /></span>
        <div className="calidad-hub-card-body">
          <div className="calidad-hub-card-eyebrow">ISO 27001-27701</div>
          <h2 className="calidad-hub-card-title">Documentos del sistema</h2>
          <p className="calidad-hub-card-copy">
            Consulta y mantiene el listado documental del SGSI con niveles, tipos, distribución, fechas y estado documental.
          </p>
        </div>
        <span className="calidad-hub-card-action">Abrir <ArrowRight size={16} /></span>
      </button>


      <button type="button" className="calidad-hub-card" onClick={onOpenInventarioDispositivos}>
        <span className="calidad-hub-card-icon"><HardDrive size={22} /></span>
        <div className="calidad-hub-card-body"><div className="calidad-hub-card-eyebrow">ISO 27001-27701</div><h2 className="calidad-hub-card-title">BG02 · Inventario de dispositivos</h2><p className="calidad-hub-card-copy">Gestiona propietarios, equipos, fabricantes, números de serie, movilidad y zona.</p></div>
        <span className="calidad-hub-card-action">Abrir <ArrowRight size={16} /></span>
      </button>

      <button type="button" className="calidad-hub-card" onClick={onOpenInventarioSoftware}>
        <span className="calidad-hub-card-icon"><KeyRound size={22} /></span>
        <div className="calidad-hub-card-body"><div className="calidad-hub-card-eyebrow">ISO 27001-27701</div><h2 className="calidad-hub-card-title">BG03 · Inventario software</h2><p className="calidad-hub-card-copy">Mantiene software, servicios de información, MFA y matriz de accesos por rol.</p></div>
        <span className="calidad-hub-card-action">Abrir <ArrowRight size={16} /></span>
      </button>

      <button type="button" className="calidad-hub-card" onClick={onOpenControlesInformatica}>
        <span className="calidad-hub-card-icon"><Settings2 size={22} /></span>
        <div className="calidad-hub-card-body"><div className="calidad-hub-card-eyebrow">ISO 27001-27701</div><h2 className="calidad-hub-card-title">BG04 · Controles informática</h2><p className="calidad-hub-card-copy">Preparación de equipos, controles periódicos y mantenimiento Fuerteventura, sin Mnto TEIDE.</p></div>
        <span className="calidad-hub-card-action">Abrir <ArrowRight size={16} /></span>
      </button>
    </section>
  );
}
